import { WithPermissions } from '@Components/common/with-permissions.tsx'
import { AdminTicketScanResponse, AuthScopes } from '@Generated/back-office-client/src'
import { Button, Flex } from '@radix-ui/themes'
import { useState } from 'react'
import { PlayerServiceAPI } from '@API/data-services/player-service.ts'
import { useQuery } from '@tanstack/react-query'

export const TicketBarcode = ({ ticketScan }: { ticketScan: AdminTicketScanResponse }) => {
  const [viewFullBarcode, setViewFullBarcode] = useState(false)

  const { data: fullTicketScan, isLoading: fullScanLoading } = useQuery({
    queryKey: [`${ticketScan.scanId}-full-scan`],
    staleTime: 86400 * 1000, // 1 day, scans are immutable
    queryFn: async () => {
      return PlayerServiceAPI.getFullTicketScan(ticketScan.scanId)
    },
    enabled: viewFullBarcode,
  })

  return (
    <Flex>
      {fullTicketScan ? (
        fullTicketScan.decryptedBarcode
      ) : (
        <Flex justify="start" className="scan-barcode-cell">
          <WithPermissions requiredPermissions={AuthScopes.readbarcodes}>
            <Button
              className="scan-table-button"
              loading={fullScanLoading}
              onClick={() => setViewFullBarcode(true)}>
              View
            </Button>
          </WithPermissions>
          *****{ticketScan.truncatedBarcode}
        </Flex>
      )}
    </Flex>
  )
}
